import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuItem } from '../../../interfaces/menu-item.interface';

@Component({
    selector: 'app-menu-item',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent {
    @Input() item!: MenuItem;
    @Input() isSelected: boolean = false;
    @Input() gtmLabel?: string;
    @Output() onSelect = new EventEmitter<string>();
} 